import { render, staticRenderFns } from "./OtherRaces.vue?vue&type=template&id=0010eaec&"
import script from "./OtherRaces.vue?vue&type=script&lang=js&"
export * from "./OtherRaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports